import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
import { BrowserCacheLocation, InteractionType, IPublicClientApplication, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MsalAuthenticationInterceptor } from './msal-authentication.interceptor';
import { RouterModule } from '@angular/router';

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;

export function MSALInstanceFactory(): IPublicClientApplication {
  const b2cConfig = environment.b2cConfig;
  if (!b2cConfig) {
    throw new Error('Configure msal in AppConfigService.configPath');
  }
  return new PublicClientApplication({
    auth: b2cConfig.auth,
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE,
    },
    system: {
      loggerOptions: {
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const config = environment.b2cConfig;
  const protectedResourceMap = 
    new Map([
      [config.apiScopes.employeeApi.endpoint, config.apiScopes.employeeApi.scopes]
    ]
    // msal.apiScopes as Iterable<readonly [string, string[]]>
  );
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  const config = environment.b2cConfig;
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: config.apiScopes.employeeApi.scopes
    },
    loginFailedRoute: '/login-failed',
  };
}

export const PROVIDERS = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: MsalInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: MsalAuthenticationInterceptor,
    multi: true,
  },
  {
    provide: MSAL_INSTANCE,
    useFactory: MSALInstanceFactory
  },
  {
    provide: MSAL_GUARD_CONFIG,
    useFactory: MSALGuardConfigFactory,
  },
  {
    provide: MSAL_INTERCEPTOR_CONFIG,
    useFactory: MSALInterceptorConfigFactory,
  },
  MsalService,
  MsalGuard,
  MsalBroadcastService,
] as Provider[]

@NgModule({
  imports: [MsalModule, RouterModule]
})
export class AuthModule {
  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: PROVIDERS
    };
  }
}
